import React from 'react'
import { useTranslation } from 'lib/i18n'

import Link from 'components/Link/Link'
import Emoji from 'components/UI/Emoji/Emoji'
import { BodySmall, H2, H5 } from 'components/UI/Typography/Typography.new'

import styles from './BusinessPageBottomCta.module.css'

const BusinessPageBottomCta = (): JSX.Element => {
  const { t } = useTranslation()

  return (
    <div className={styles.wrapper} data-cy="businessPageBottomCta">
      <H2 element="h2" theme="tertiary">
        {t('BusinessPageBottomCta.title', 'Take the next step')}
      </H2>
      <div className={styles.buttonWrapper}>
        <Link href="/">
          <a data-cy="businessPageBottomCtaShowAll">
            <div className={styles.button}>
              <Emoji
                className={styles.emoji}
                emoji="smiling-face-with-sunglasses"
              />
              <div className={styles.buttonText}>
                <H5 theme="tertiary">
                  {t('BusinessPageBottomCta.showAll', 'Show all talent')}
                </H5>
                <BodySmall theme="tertiary">
                  {t(
                    'BusinessPageBottomCta.showAllText',
                    'Find the right talent for you and make an order right away. No fuzz, only buzz.',
                  )}
                </BodySmall>
              </div>
            </div>
          </a>
        </Link>

        <Link href="/page/business-form">
          <a data-cy="businessPageBottomCtaContactUs">
            <div className={styles.button}>
              <Emoji className={styles.emoji} emoji="mobile-phone" />
              <div className={styles.buttonText}>
                <H5 theme="tertiary">
                  {t('BusinessPageBottomCta.contactUs', 'Contact us')}
                </H5>
                <BodySmall theme="tertiary">
                  {t(
                    'BusinessPageBottomCta.contactUsText',
                    'Let us know what you need and we’ll create something great together',
                  )}
                </BodySmall>
              </div>
            </div>
          </a>
        </Link>
      </div>
    </div>
  )
}

export default BusinessPageBottomCta
